import styled from 'styled-components';
export const InfiniteScrollLoadingWrapper = styled.div `
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  background: none;
  outline: none;
  border: none;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=InfiniteScrollLoading.styled.js.map